/**
 * A class to provide some structure to the various 'opts' being passed between print methods.
 * The most common options can be given in the constructor.
 *
 * @constructor
 *
 * @param {?string} [printType]
 */
const { populate } = require('@/functions/objects');

class PrintJobOptions {
    /**
     * @param {string} printType
     * @param {{}} [options]
     * @param {PrintJobOptions} [mergeAdditionalOptions]
     */
    constructor(printType, options = {}, mergeAdditionalOptions = null) {
        /**
         * Array of CSS classes to add to the printout.
         *
         * @type {string[]}
         */
        this.classes = [];

        /**
         * Callback for just before the job is sent to the printer.
         *
         * @type {?Function}
         */
        this.onBeforePrintCall = null;

        /**
         * Open the cash drawer when printing?
         * This only has an effect for Star printers.
         *
         * @type {boolean}
         */
        this.openCashDrawer = true;

        /**
         * One of the PrintType constants.
         *
         * @see {PrintType}
         *
         * @type {?string}
         */
        this.printType = printType || null;

        /**
         * @type {PrintRouting}
         */
        this.printRouting = null;

        /**
         * Should a dot be added at the bottom of the printout to fix the bottom margin not appearing?
         * Default is true.
         *
         * @type {boolean}
         */
        this.addFooterDot = true;

        /**
         * @internal
         * This is for the internal use of the Printer class.
         * It will be set to a function to resolve the relevant promise when printing is complete.
         *
         * @type {Function}
         */
        this.onSuccess = null;

        /**
         * @internal
         * This is for the internal use of the Printer class.
         * It will be set to a function to reject the relevant promise when printing fails.
         *
         * @type {Function}
         */
        this.onFailure = null;

        if (options) {
            populate(this, options);
        }

        if (mergeAdditionalOptions) {
            this.merge(mergeAdditionalOptions);
        }
    }

    /**
     * @param {PrintJobOptions} opts
     */
    merge(opts) {
        for (let key in opts) {
            if (this.hasOwnProperty(key) && opts[key] !== null) {
                this[key] = opts[key];
            }
        }
    }
}

module.exports = PrintJobOptions;
